export default {"src":"/_next/static/media/facebook-icon-27-27.f0e8a338.svg","height":27,"width":28};